const SYNC_DEVIATION = "app/serverTime/SYNC_DEVIATION";

export default {
  SYNC_DEVIATION,
};
